
import { CompanyClient } from '@/services/Services';
import { Options, Vue } from 'vue-class-component';
import AddNewPremisesModal from '../modals/addNewPremisesModal.vue';
import store from '@/store';
import * as OM from '@/Model';
import * as VM from '@/viewModel';

@Options({
    components: { },
})
export default class Premises extends Vue {

    premises: OM.Premises[] = [];

    created() {
        this.init();
    }

    init() {
        CompanyClient.getPremisesByCompany()
        .then(x => {
            this.premises = x;
        })
    }

    get isReadOnly() {
        return store.state.loggedUser.role == VM.Roles.ReadOnly;
    }

    addOrEditPremises(existingPremises: OM.Premises | null) {
        this.$opModal.show(AddNewPremisesModal, {
            premises: existingPremises,
            callback: () => {
                this.$opModal.closeLast();
                this.init();
            }
        })
    }

}
